var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanetMars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 336,
    height: 336,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 168,
    cy: 168,
    r: 168
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 168,
    cy: 168,
    r: 168
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 168,
    cy: 168,
    r: 168
  }), /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: 168,
    cy: 168,
    r: 168
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "#FF6A45",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9B6B",
    fillRule: "nonzero",
    d: "M102 36c0-6.627-5.373-12-12-12H55c-6.627 0-12-5.373-12-12S48.373 0 55 0h156c6.627 0 12 5.373 12 12s-5.373 12-12 12h-56l-.001.01c-6.395.263-11.499 5.53-11.499 11.99S148.604 47.727 155 47.99V48H168c6.627 0 12 5.373 12 12s-5.373 12-12 12H41c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.627 0 12-5.373 12-12zm172 12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-5c-6.627 0-12-5.373-12-12s5.373-12 12-12h5z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9B6B",
    fillRule: "nonzero",
    d: "M209 324c0-6.627-5.373-12-12-12h-35c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12h-56l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99v.01H275c6.627 0 12 5.373 12 12s-5.373 12-12 12H148c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.627 0 12-5.373 12-12zm172 12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-5c-6.627 0-12-5.373-12-12s5.373-12 12-12h5z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D04237",
    fillRule: "nonzero",
    d: "M217 264c6.627 0 12 5.373 12 12s-5.373 12-12 12h-62c-6.627 0-12-5.373-12-12s5.373-12 12-12h62zm-117 0c6.627 0 12 5.373 12 12s-5.373 12-12 12H80c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm163-96c6.627 0 12 5.373 12 12s-5.373 12-12 12H112l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h19c6.627 0 12 5.373 12 12s-5.373 12-12 12H11c-6.627 0-12-5.373-12-12s5.373-12 12-12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12h-64c-6.627 0-12-5.373-12-12s5.373-12 12-12h284zm-52 48c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zM139 72c6.627 0 12 5.373 12 12s-5.373 12-12 12H99c-6.627 0-12-5.373-12-12s5.373-12 12-12h40zm209 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12s5.373-12 12-12h40z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#h)",
    opacity: 0.078,
    d: "M169-16h184v368H169z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetMars);
export default __webpack_public_path__ + "static/media/planet-mars.f9dc1ca45a888b568829cd38ca525dcb.svg";
export { ForwardRef as ReactComponent };